<template>
    <div class=" pa-0 ma-0 d-flex flex-column">
        
        <component :is="getEditorComponent()"
                class="editorComponent  pa-0 ma-0 flex-grow-1 flex-shrink-1  "
                ref="editor"
                :context="getContext()">
        </component>
        
    </div>
</template>

<script>
import EditorState from './EditorState.js';

export default {
    name: 'DefaultEditorPane',
    props: ['context', 'editorComponent'],
    data () {
        return {
            billData: {
                billId: -1,  //-1表示新数据
            },
            editorState: EditorState.BROWSING,
        }
    },
    methods: {
        initComponent () {
            console.log('EditPane begin init components');

        },
        initSignals () {
            if(!this.signalInited){
                console.log('EditPane begin init signals');
                this.initNewBillAction();
                this.initEditCancelAction();
                this.initBrowseBillAction();
                this.initEditBillAction();
                this.initSaveBillAction();
                this.initStopAction();
                this.initRestoreAction();
                this.signalInited = true;
            }
        },
        isEmptyData () {
            return this.bill.isEmptyData(this.billData);
        },
        initNewBillAction () {
            let me = this;
            let signal = null;
            signal = this.getSignals().newBillAsked;
            signal.add(function () {
                let billData = me.bill.getEmptyData();
                me.setState(EditorState.LOADING);
                me.getEditor().loadData(billData, false,function (returnedBillData) {
                    me.billData = me.deepCopy(returnedBillData);
                    me.setState(EditorState.EDITING);
                });
            });
        },
        initEditCancelAction () {
            let me = this;
            let signal = null;
            signal = this.getSignals().editCancelAsked;
            signal.add(function () {
                let billData = me.deepCopy(me.billData);
                me.setState(EditorState.LOADING);
                me.getEditor().loadData(billData,false, function () {
                    me.setState(EditorState.BROWSING);
                }, function () {
                    me.setState(EditorState.EDITING);
                });
            });
        },
        initBrowseBillAction () {
            let me = this;
            let signal = null;
            signal = this.getSignals().browseBillAsked;
            signal.add(function (bill) {
                let billData = me.deepCopy(bill);
                
                me.setState(EditorState.LOADING);
                me.getEditor().loadData(billData,true, function (returnedBillData) {
                    me.billData = me.deepCopy(returnedBillData);
                    me.setState(EditorState.BROWSING);
                }, function () {
                    me.setState(EditorState.BROWSING);
                });
            });
        },
        initEditBillAction () {
            let me = this;
            let signal = null;
            signal = this.getSignals().editBillAsked;
            signal.add(function () {
                me.setState(EditorState.EDITING);
                me.getEditor().setState(EditorState.EDITING);
            });
        },
        initSaveBillAction () {
            let me = this;
            let signal = null;
            signal = this.getSignals().saveBillAsked;
            signal.add(function () {
                me.setState(EditorState.LOADING);
                me.getEditor().saveData(function (saveReturnBillData,needRefresh) {
                    me.billData = me.deepCopy(saveReturnBillData);
                    let aCopy = me.deepCopy(saveReturnBillData);
                    me.getEditor().loadData(aCopy,/*(me.billData,*/needRefresh, function (loadReturnData) {
                        me.billData = me.deepCopy(loadReturnData);
                        me.setState(EditorState.BROWSING);
                    }, function () {
                        me.setState(EditorState.EDITING);
                    });

                }, function () {
                    me.setState(EditorState.EDITING);
                });
            });
        },
        initStopAction(){
            let me = this;
            let signal = null;
            signal = this.getSignals().stopAsked;
            signal.add(function () {
                me.setState(EditorState.LOADING);
                me.getEditor().stopData(function (stopReturnBillData,needRefresh) {
                    me.billData = me.deepCopy(stopReturnBillData);
                    let aCopy = me.deepCopy(stopReturnBillData);
                    me.getEditor().loadData(aCopy,/*me.billData,*/needRefresh, function (loadReturnData) {
                        me.billData = me.deepCopy(loadReturnData);
                        me.setState(EditorState.BROWSING);
                    }, function () {
                        me.setState(EditorState.BROWSING);
                    });

                }, function () {
                    me.setState(EditorState.BROWSING);
                });
            });
        },
        initRestoreAction(){
            let me = this;
            let signal = null;
            signal = this.getSignals().restoreAsked;
            signal.add(function () {
                me.setState(EditorState.LOADING);
                me.getEditor().restoreData(function (restoreReturnBillData,needRefresh) {
                    me.billData = me.deepCopy(restoreReturnBillData);
                    let aCopy = me.deepCopy(restoreReturnBillData);
                    me.getEditor().loadData(aCopy,/*me.billData,*/needRefresh, function (loadReturnData) {
                        me.billData = me.deepCopy(loadReturnData);
                        me.setState(EditorState.BROWSING);
                    }, function () {
                        me.setState(EditorState.BROWSING);
                    });

                }, function () {
                    me.setState(EditorState.BROWSING);
                });
            });
        },
        getSignals () {
            return this.context.signals;
        },
        getEditorComponent () {
            return this.editorComponent;
        },
        getContext () {
            return this.context;
        },
        getEditor () {
            return this.$refs.editor;
        },
        getBillData () {
            return this.billData;
        },
        getBillId () {
            return this.billData.billId;
        },
        getEditorState () {
            return this.editorState
        },
        isLoading () {
            return this.editorState == EditorState.LOADING;
        },
        isBrowsing () {
            return this.editorState == EditorState.BROWSING;
        },
        isEditing () {
            return this.editorState == EditorState.EDITING;
        },
        setState (state) {
            this.editorState = state;
            let editor = this.getEditor();
            if (editor && editor.setState)
                editor.setState(state);
        },
        //用于指示按钮可用性
        canEdit () {
            let editor = this.getEditor();
            if (editor && editor.canEdit)
                return editor.canEdit(this.billData);
            return false;
        },
        canDelete () {
            let editor = this.getEditor();
            if (editor && editor.canDelete)
                return editor.canDelete(this.billData);
            return false;
        },

        canSave () {
            let editor = this.getEditor();
            if (editor && editor.canSave)
                return editor.canSave(this.billData);
            return false;
        },
        canStop () {
            let editor = this.getEditor();
            if (editor && editor.canStop)
                return editor.canStop(this.billData);
            return false;
        },
        canRestore () {
            let editor = this.getEditor();
            if (editor && editor.canRestore)
                return editor.canRestore(this.billData);
            return false;
        },
        canAudit () {
            let editor = this.getEditor();
            if (editor && editor.canAudit)
                return editor.canAudit(this.billData);
            return false;
        },
        canCancelAudit () {
            let editor = this.getEditor();
            if (editor && editor.canCancelAudit)
                return editor.canCancelAudit(this.billData);
            return false;
        },
        canVoid () {
            let editor = this.getEditor();
            if (editor && editor.canVoid)
                return editor.canVoid(this.billData);
            return false;
        },
        canCancelVoid () {
            let editor = this.getEditor();
            if (editor && editor.canCancelVoid)
                return editor.canCancelVoid(this.billData);
            return false;
        },
        canPutOn () {
            let editor = this.getEditor();
            if (editor && editor.canPutOn)
                return editor.canPutOn(this.billData);
            return false;
        },
        canWithdraw () {
            let editor = this.getEditor();
            if (editor && editor.canWithdraw)
                return editor.canWithdraw(this.billData);
            return false;
        },
        //初始化信号处理逻辑
        /*
        initNewBillAskedSignal () {
            let me = this;
            let signal = null;
            signal = this.getSignals().newBillAsked;
            signal.add(function () {
                let billData = { billId: -1 };
                me.setState(EditorState.LOADING);
                if (!me.getEditor().loadData) {
                    throw new Error("editor not found loadData function");
                    return;
                }
                me.getEditor().loadData(billData, function () {
                    me.setState(EditorState.EDITING);
                });
            });
        },
        */
       /*
        loadData () {

            let signal = this.getContext().billLoaded;
            signal.dispatch();
        }
        */
        deepCopy(jsonObj){
            return JSON.parse(JSON.stringify(jsonObj));            
        }
    },
    created () {
        this.bill = this.context.bill;
        this.signals = this.context.signals;
        this.initComponent();
        this.initSignals();
    },
    computed: {

    }
}
</script>

<style scoped>
    .editorContainer{
        overflow: auto;
    }
</style>
